export default {
  namespaced: true,
  state: {
    meeting_statuses: [],
  },
  mutations: {
    set_meeting_statuses(state, payload) {
      state.meeting_statuses = [...payload];
    },
  },
  getters: {
    get_meeting_statuses: (state) => state.meeting_statuses,
  },
  actions: {
    set_meeting_statuses({ commit }, payload) {
      commit("set_meeting_statuses", payload);
    },
  },
};